export default __webpack_public_path__ + "22125f7.png";